import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { api_base } from "../env";

const EventContext = createContext();

export function EventProvider({ children }) {
  const [EventsData, setEventsData] = useState([]);
  const [isEvent, setIsEvent] = useState(false);
  const [loading, setLoading] = useState(false);

  // Check event code and update state
  const checkEventCode = useCallback(async (code) => {
    setLoading(true);
    try {
      const response = await axios.get(`${api_base}event/VerifieCode`, {
        params: { code },
      });
      setIsEvent(true);
      setEventsData(response.data.data);
      Cookies.set("codeEvent", code, { expires: 1 });
      return true;
    } catch (error) {
      setIsEvent(false);
      setEventsData([]);
      Cookies.remove("codeEvent");
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  function logoutEvent() {
    Cookies.remove("codeEvent");
    setEventsData();
    setIsEvent(false);
  }

  // On mount, check event if code exists in cookies
  useEffect(() => {
    const code = Cookies.get("codeEvent");
    if (code) {
      checkEventCode(code);
    }
  }, [checkEventCode]);
  console.log("event data useEvent  :", EventsData);
  return (
    <EventContext.Provider
      value={{ EventsData, isEvent, loading, checkEventCode, logoutEvent }}
    >
      {children}
    </EventContext.Provider>
  );
}

export function useEvent() {
  return useContext(EventContext);
}
